import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'container__facebook',
})`
  .login-container__button {
    margin: 0;
  }
`;
